import { useEffect, useState } from "react";
import { ANALYTICS_CONSENT_KEY, disableAnalytics, enableAnalytics } from "@/lib/analytics";

const readPreference = () => {
    try {
        const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
        return value === "granted" || value === "denied" ? value : null;
    } catch {
        return null;
    }
};

const persistPreference = (value) => {
    try {
        window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
    } catch {
        // La privacidad por defecto se mantiene aunque el navegador bloquee storage.
    }
};

export default function AnalyticsConsent() {
    const [preference, setPreference] = useState(readPreference);
    const [open, setOpen] = useState(() => readPreference() === null);

    useEffect(() => {
        if (preference === "granted") enableAnalytics();
        if (preference === "denied") disableAnalytics();
    }, [preference]);

    const choose = (value) => {
        persistPreference(value);
        setPreference(value);
        setOpen(false);
    };

    if (!open) {
        return (
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="fixed bottom-3 left-3 z-[100] rounded-md border border-slate-300 bg-white px-3 py-2 text-xs font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-teal-500 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
                aria-label="Configurar privacidad y analítica"
            >
                Privacidad
            </button>
        );
    }

    return (
        <section
            className="fixed bottom-4 left-1/2 z-[110] w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2 border border-slate-200 bg-white p-5 shadow-2xl dark:border-slate-700 dark:bg-slate-950"
            role="dialog"
            aria-modal="false"
            aria-labelledby="analytics-consent-title"
            aria-describedby="analytics-consent-description"
        >
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div className="max-w-xl">
                    <h2 id="analytics-consent-title" className="text-base font-semibold text-slate-950 dark:text-white">
                        Privacidad y medición
                    </h2>
                    <p id="analytics-consent-description" className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
                        Usamos analítica opcional para entender el uso general y mejorar LicitX. No activamos publicidad, grabación de sesiones ni captura automática de formularios. Puedes rechazarla y usar todas las funciones igualmente.
                    </p>
                </div>
                <div className="flex shrink-0 flex-wrap gap-2">
                    <button
                        type="button"
                        onClick={() => choose("denied")}
                        className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 dark:border-slate-600 dark:text-slate-200 dark:hover:bg-slate-900"
                    >
                        Rechazar
                    </button>
                    <button
                        type="button"
                        onClick={() => choose("granted")}
                        className="rounded-md bg-teal-600 px-4 py-2 text-sm font-semibold text-white hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                    >
                        Aceptar analítica
                    </button>
                </div>
            </div>
        </section>
    );
}
